module.exports = __webpack_public_path__ + "assets/img/icon-spring-boot-admin.svg";


//////////////////
// WEBPACK FOOTER
// ./src/main/frontend/assets/img/icon-spring-boot-admin.svg
// module id = ./src/main/frontend/assets/img/icon-spring-boot-admin.svg
// module chunks = 1